var map = {
	"./Bilibili.png": "W728",
	"./Dailymotion.png": "0VeZ",
	"./Facebook.png": "GCvE",
	"./Likee.png": "3vhH",
	"./Niconico.png": "cZOt",
	"./Rumble.png": "e3Uo",
	"./SoundCloud.png": "g8MZ",
	"./TikTok.png": "9iJv",
	"./Twitch.png": "jCNO",
	"./Vimeo.png": "OUT8",
	"./X.png": "DX6O",
	"./YouTube.png": "IZqk"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "rcOg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sitesLogo ^\.\/.*\.png$
// module id = rcOg
// module chunks = 2